<template>
    <div id="extended-surveillance-content" style="display: inline-block; width: 100%">
        <div class="tab-header blue-grey lighten-5">
            <h2 class="tab-title">
                Surveillance
            </h2>
            <!-- TODO Bouton Tout décocher -->
            <div class="row toolbar">
                <div class="input-field col s12">
                    <button
                        class="uncheckAll"
                        @click="resetSelectedVariables()"
                        title="Décoche "
                    >
                        <span class="unckeck-icon"/>
                        <span class="uncheck-label">
              Tout décocher
            </span>
                    </button>
                </div>
            </div>
            <div class="row toolbar">
                <div class="input-field col s12">
                    <label for="utamSelector">
                        UTAM :
                    </label>
                    <select
                        ref="utamSelector"
                        v-model="selectedUtam"
                        @change="updateSurveillanceList()"
                    >
                        <option value disabled selected>
                            Sélectionnez un UTAM
                        </option>
                        <option v-if="this.infosLecteur && !this.infosLecteur[0].isOnlyLecteur" value="all">
                            Tous les UTAMS
                        </option>
                        <option
                            v-for="u in utamData"
                            :key="u.utam"
                            :value="u.utam"
                        >
                            {{ u.libelle }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row toolbar">
                <div class="input-field col s12">
                    <label for="surveillanceSelector">
                        Liste de surveillance :
                    </label>
                    <select
                        ref="surveillanceSelector"
                        class="dynamicSelect"
                        v-model="selectedSurveillance"
                        @change="updateSurveillanceTree()"
                    >
                        <template v-if="selectedUtam === 'all'">
                            <option value="" disabled selected>
                                Listes de surveillance
                            </option>
                            <option
                                v-for="item in getSurveillanceData"
                                :key="item.id"
                                :value="item.id"
                            >
                                {{ item.libelle }}
                            </option>
                        </template>
                        <template v-else>
                            <option value="" disabled selected>
                                Listes de surveillance
                            </option>
                            <option
                                v-for="item in getSurveillanceData"
                                :key="item.id"
                                :value="item.id"
                            >
                                {{ item.libelle }}
                            </option>
                        </template>
                    </select>
                </div>
            </div>
            <div class="row toolbar">
                <div id="filterArbo" class="input-field col s12">
                    <div class="input-wrapper">
                        <input type="text" v-model="filterResearch" placeholder="Filtrer l'arborescence"/>
                        <img src="../../assets/loupe.svg" alt="Icône recherche" class="icon" />
                    </div>
                </div>
            </div>
            
            <div class="row toolbar">
                <!-- <SurveillanceLoadView @viewLoaded="setView($event)"/> -->
                <div id="load-view-open">
                    <button
                        class="showLoadView"
                        type="button"
                        @click="showLoadViewModal"
                        title="Charger une vue du graphique enregistrée dans l'application"
                    >
                        <font-awesome-icon class="load-view-icon" :icon="['fa', 'times-circle']" fixed-width/>
                        <span class="load-view-label">
              Vues enregistrées
            </span>
                    </button>
                </div>
            </div>
            <div v-if="!loading"  id="expand-all-div" >
                <label for="expand-all" id="expand-all-label"> Étendre tous les noeuds </label>
                <input id="expand-all" type="checkbox" v-model="expandAll" :disabled="!isFilterActive" :title="!isFilterActive ? 'Filtrez l\'arborescence pour activer cette option' : ''">
            </div>
        </div>
        <div v-if="!loading">
            <div v-if="this.arborescenceData.length == 0" id="message-surv-sans-var">
                <div> La surveillance ne possède pas de variable </div>
            </div>

            <Tree v-model:selectionKeys="computedSelectedKeys"
                  v-model:expandedKeys="computedExpandedKeys"
                  :value="getSurveillanceTree"
                  selectionMode="checkbox"
                  class="blue-grey lighten-5"
                  @node-select="onNodeSelect"
                  @node-unselect="onNodeUnselect" />
            <div id="affichage-suivi-div">
                <label for="affichage-suivi" id="affichage-suivi-label"> Afficher éléments suspendus/abandonnés </label>
                <input id="affichage-suivi" type="checkbox" v-model="affichageSuiviAbandonneOuSuspendu" />
            </div>
        </div>
        <div v-else-if="loading">
            <Loading/>
        </div>
    </div>
</template>
<script>
import {surveillanceService} from '../../services'
import {mapGetters} from 'vuex'
import Loading from '@/components/Loading.vue'
import Tree from '@/extendedModuleComponents/primevue/tree/Tree.vue'
// import Tree from 'primevue/tree'
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

import {dom} from '@fortawesome/fontawesome-svg-core'

dom.watch()

export default {
    name: 'ExtendedSurveillance',
    components: {
        Loading,
        Tree
    },
    props: {
        infosLecteur: Object
    },
    emits: ['reset-graph', 'show-load-view'],
    created() {
        this.eventBus.on('update-tree', async (model)  => {
            if (model.survId !== this.selectedSurveillance){
                const id = model.guidVariable.split('_')[0];
                await surveillanceService.getVariableFromArbo(id).then(async (d) => {
                    this.selectedUtam = d.utam
                    this.selectedSurveillance = d.idSurveillance
                    await this.getAllSurveillance(d.utam)
                })
            }
            this.guidVariableChronique = null;
            if (model.isCreated == null){
                await this.updateSurveillanceTree();
                const guid = model.guidVariable
                await this.$store.dispatch('surveillance/deleteVariableData', { variableGuid: guid })
                await this.$store.dispatch('surveillance/deleteSelectedKey', { selectedKeysToDelete: [guid] })
                return;
            }
            this.guidVariableChronique = model.guidVariable
            await this.updateSurveillanceTree()
        })

        this.eventBus.on('modal-vc-check', async (model)  => {
            if (this.modalVC !== null && model.variableGuid === this.modalVC.guid && this.modalVC.isChecked === true) {
                this.modalVC=null;
                model.done(true);
                return;
            }
            model.done(false);
            return;
        })

        this.eventBus.on('reset-utam-surv', () => {
            this.$store.dispatch('surveillance/setSelectedSurv', { survId: '' })
            this.$store.dispatch('surveillance/setSelectedUtam', { utam: '' })
        })
    },
    data: function () {
        return {
            affichageSuiviAbandonneOuSuspendu: false,
            utamData: [
                {
                    'utam': 'UCO',
                    'libelle': 'UTAM Centre-Ouest'
                },
                {
                    'utam': 'UE',
                    'libelle': 'UTAM Est'
                },
                {
                    'utam': 'UN',
                    'libelle': 'UTAM Nord'
                },
                {
                    'utam': 'US',
                    'libelle': 'UTAM Sud'
                }
            ],
            dateRange: null,
            selectedUtam: null,
            surveillanceData: null,
            selectedSurveillance: null,
            arborescenceData: null,
            arborescenceViewSurv: null,
            surveillanceTree: null,
            selectedVariables: {},
            selectedKeys: {},
            loading: true,
            loadQueue: [],
            guidVariableChronique: null,
            filterResearch:"",
            modalVC: null,
            expandAll: false
        }
    },
    computed: {
        ...mapGetters('authentication', [
            'user'
        ]),
        getSurveillanceData() {
            // Récupère la liste des surveillances (de l'UTAM sélectionné) à afficher dans la liste déroulante 'Listes de surveillance'
            if (this.surveillanceData) {
                return this.sortList(this.surveillanceData, 'libelle')
            } else {
                return null
            }
        },

        getSurveillanceTree() {
            const activeFilterResearch = this.filterResearch.length < 3;
            if (this.arborescenceData && Object.keys(this.arborescenceData).length > 0) {
                //var arborescence = this.sortList(this.arborescenceData, 'cheminElement', 'libVariable') // Le tri s'effectue côté Back maintenant (allège le front)
                var tree = {}
                this.arborescenceData.forEach(item => {
                    tree = this.prepareViewsTree(tree, item.cheminElement.split(' ==> '), item)
                })
                const response= this.createSurveillanceTree(tree, [],'',activeFilterResearch)
                return response.responseTree
            } else {
                return null
            }
        },
        computedSelectedKeys: {
            // Nodes de l'arborescence de la surveillance déjà sélectionnés
            get() {
                this.setSelectedKeys()
                return this.selectedKeys
            },
            set(newvalue) {
                this.$store.dispatch('surveillance/setSelectedKeys', {selectedKeys: newvalue})
                this.setSelectedKeys()
            }
        },
        computedExpandedKeys: {
            // Nodes de l'arborescence de la surveillance déjà ouverts
            get() {
                this.setExpandedKeys()
                return this.expandedKeys
            },
            set(newvalue) {
                this.$store.dispatch('surveillance/setExpandedKeys', {expandedKeys: newvalue}) // save to store
                window.sessionStorage.setItem('gp_expandedKeys', JSON.stringify(Object.entries(newvalue))) // save to session
                this.setExpandedKeys()
            }
        },
        isFilterActive() {
            return this.filterResearch && this.filterResearch.trim().length >= 3
        }
    },
    watch: {
        selectedSurveillance(newSurv) {
            this.expandAll = false
            this.$store.dispatch('surveillance/resetExpandedKeys')
            window.sessionStorage.removeItem('gp_expandedKeys')
        },
        selectedUtam(utam) {
            this.$store.dispatch('surveillance/setSelectedUtam', { utam: utam })
        },
        affichageSuiviAbandonneOuSuspendu() {
            this.updateSurveillanceTree()
        },
        expandAll() {
            this.expandAll ? this.expandElements(this.getSurveillanceTree) : this.computedExpandedKeys = {}
        },
        filterResearch() {
            // Décocher "expand all" quand le filtre est supprimé
            if (!this.isFilterActive) {
                this.expandAll = false
            }
        },
        infosLecteur() {
            this.updateSurveillanceList()
        }
    },
    methods: {
        setSelectedKeys() {
            this.selectedKeys = this.$store.getters['surveillance/surveillanceSelectedKeys']
        },
        setExpandedKeys() {
            var sessionArray = window.sessionStorage.getItem('gp_expandedKeys')
            if ((sessionArray !== null) && (sessionArray !== undefined) && !this.expandAll) {
                this.expandedKeys = Object.fromEntries(JSON.parse(sessionArray)) // read from session
            } else {
                this.expandedKeys = this.$store.getters['surveillance/surveillanceExpandedKeys'] // read from store
            }
        },
        findNodeByGuid(guid, nodes = this.getSurveillanceTree) {
            if (!nodes) return null
            for (const node of nodes) {
                if (node?.data?.guidVariable === guid) {
                    return node
                }
                if (node.children && node.children.length > 0) {
                    const found = this.findNodeByGuid(guid, node.children)
                    if (found) return found
                }
            }
            return null
        },

        async getAllSurveillance(userUtam = null) {
            // Enregistre l'UTAM sélectionné en mémoire
            // Requête (à l'API) la liste des surveillances correspondant à l'UTAM choisi
            // Présélectionne la dernière surveillance sélectionnée (de l'UTAM choisi)

            this.setLoading('getAllSurveillance', true)
            var ut = null
            if (userUtam) {
                ut = userUtam
            } else {
                ut = this.selectedUtam
            }

            if (ut && ut !== '' && ut !== 'all') {
                this.selectedUtam = ut
                await surveillanceService.getAllByUtam(ut).then(d => {
                    this.surveillanceData = d
                    this.selectedSurveillance = this.$store.getters['surveillance/surveillanceSelectedSurv'] ?? this.selectedSurveillance // read from store
                    this.arborescenceData = []
                })
                this.setLoading('getAllSurveillance', false)
            } else if (ut === '') {
                this.selectedUtam = ut
                let _surveillanceData = []
                this.utamData.forEach(currUtam => {
                    surveillanceService.getAllByUtam(currUtam.utam).then(d => {
                        _surveillanceData.push(...d)
                        this.surveillanceData = _surveillanceData
                        this.selectedSurveillance = ''
                        this.$store.dispatch('surveillance/setSelectedSurv', {survId: this.selectedSurveillance})
                        this.arborescenceData = []
                    })
                })
                this.setLoading('getAllSurveillance', false)
            } else if (ut === 'all') {
                this.selectedUtam = ut
                surveillanceService.getAll().then(d => {
                    this.surveillanceData = d
                    this.selectedSurveillance = ''
                    this.$store.dispatch('surveillance/setSelectedSurv', {survId: this.selectedSurveillance})
                    this.arborescenceData = []
                })
                this.setLoading('getAllSurveillance', false)
            } else {
                this.surveillanceData = []
                this.selectedSurveillance = ''
                this.$store.dispatch('surveillance/setSelectedSurv', {survId: this.selectedSurveillance})
                this.arborescenceData = []
                this.setLoading('getAllSurveillance', false)
            }

            if (this.infosLecteur && this.infosLecteur.length > 0 && this.infosLecteur[0].isOnlyLecteur) {
                this.surveillanceData = this.surveillanceData.filter(item => this.infosLecteur.some(l => l.idSurveillance === item.id && l.accesDonneesAutres))
                this.selectedSurveillance = this.surveillanceData[0]
                this.$store.dispatch('surveillance/setSelectedSurv', { survId: this.selectedSurveillance })
            }
        },
        getSurveillanceArborescence() {
            this.setLoading('getSurveillanceArborescence', true)
            if (this.selectedSurveillance !== '' && this.surveillanceData.find(s => s.id == this.selectedSurveillance) !== undefined) {
                surveillanceService.getArborescence(this.selectedSurveillance).then(async (d) => {
                    this.arborescenceData = d
                    this.setLoading('getSurveillanceArborescence', false)
                    if (this.guidVariableChronique) {
                        const guid = this.guidVariableChronique
                        this.guidVariableChronique = null
                        await this.$nextTick()
                        await this.selectAndExpandChronicleVariable(guid)
                    }
                }).catch(d => {
                    if (d.status === 404) {
                        this.arborescenceData = []
                        this.setLoading('getSurveillanceArborescence', false)
                    }
                })
            } else {
                this.arborescenceData = []
                this.setLoading('getSurveillanceArborescence', false)
            }
        },
        setLoading(process, running) {
            if (this.loadQueue.includes(process) && !running) {
                this.loadQueue.splice(this.loadQueue.indexOf(process), 1)
            } else if (!this.loadQueue.includes(process) && running) {
                this.loadQueue.push(process)
            }

            this.loading = this.loadQueue.length > 0
        },
        sortList(listToSort, property1, property2 = '') {
            return listToSort.sort(function (a, b) {
                var aProp = a[property1]
                var bProp = b[property1]
                if (property2 !== '') {
                    aProp += a[property2]
                    bProp += b[property2]
                }
                if (typeof aProp === 'string') {
                    return aProp.localeCompare(bProp, 'fr', {sensitivity: 'base'})
                }

                return aProp - bProp
            })
        },
        initUtam() {
            let storeUtam = this.$store.getters['surveillance/selectedUtam']
            let utamToSelect = null
            let selectedUtamToChange = true

            if (this.selectedUtam === null) {
                if (storeUtam !== null) {
                    utamToSelect = storeUtam
                } else {
                    utamToSelect = this.user.utam
                }
            }
            else if (this.selectedUtam !== storeUtam) {
                if (storeUtam !== null) {
                    utamToSelect = this.selectedUtam
                    selectedUtamToChange = false
                } else {
                    utamToSelect = this.user.utam
                }
            }

            this.$store.dispatch('surveillance/setSelectedUtam', { utam: utamToSelect })
            if (selectedUtamToChange) this.changeSelectedUtam(utamToSelect)

            return utamToSelect
        },
        resetUtam(event) {
            this.changeSelectedUtam(this.user.utam)
        },
        changeSelectedUtam(ut) {
            var select = this.$refs.utamSelector
            if (ut) {
                Array.from(select.children).forEach((x, i) => {
                    if (i === 0) {
                        x.setAttribute('selected', 'false')
                    }
                    if (x.value === ut) {
                        select.selectedIndex = i // todo 1.4.4 : à debug
                        x.setAttribute('selected', 'true') // x.setAttribute('selected', 'selected')
                    }
                })
            } else {
                select.selectedIndex = 1 // todo 1.4.4 : à debug
                this.selectedUtam = null
                Array.from(select.children)[0].setAttribute('selected', 'false')
                Array.from(select.children)[1].setAttribute('selected', 'selected')
            }
        },

        updateSurveillanceList() {
            this.setLoading('updateSurveillanceList', true)
            this.getAllSurveillance()
            this.changeSelectedSurveillance()
            this.setLoading('updateSurveillanceList', false)
        },

        changeSelectedSurveillance() {
            var select = this.$refs.surveillanceSelector
            Array.from(select.children).forEach((x, i) => {
                x.setAttribute('selected', 'false')
            })
            select.selectedIndex = 1
            this.selectedSurveillance = ''
            Array.from(select.children)[0].setAttribute('selected', 'selected')
        },

        async updateSurveillanceTree() {
            this.$store.dispatch('surveillance/setSelectedSurv', {survId: this.selectedSurveillance}) // save to store
            await this.getSurveillanceArborescence()
        },
        prepareViewsTree(tree, nodes, item, depth = 0) {
            var populatedTree = Object.assign({}, tree) // à changer 1.4.4 ?
            var currentDepth = nodes[depth]

            if (populatedTree[currentDepth] === undefined) {
                populatedTree[currentDepth] = {}
            }

            if (depth === nodes.length - 1) {
                var index = Object.keys(populatedTree[currentDepth]).length
                var path = item.cheminElement.split(' ==> ')

                var treeNode = {
                    libVariable: item.libVariable,
                    libUnite: item.libUnite,
                    modeMesure: item.modeMesure,
                    typeElement: item.typeElement,
                    typeAttachement: item.typeAttachement,
                    guidVariable: item.guidVariable,
                    mnemo:item.mnemo,
                    elementPath: path,
                    idVariableCalculee: item.idVariableCalculee,
                    codeSuivi: item.codeSuivi
                }
                if ('libVue' in item) {
                    treeNode.libVue = item.libVue
                    treeNode.guidVariable = item.id
                }
                populatedTree[currentDepth][index] = treeNode

                return populatedTree
            } else {
                populatedTree[currentDepth] = this.prepareViewsTree(populatedTree[currentDepth], nodes, item, depth + 1)
            }

            return populatedTree
        },

        countSelectableVariables(nodes) {
            let count = 0;
            if (!nodes) return 0;
            for (const node of nodes) {
                if (node.children && node.children.length > 0) {
                    count += this.countSelectableVariables(node.children);
                } else if (node.selectable !== false) {
                    count++;
                }
            }
            return count;
        },
        
        createSurveillanceTree(levelArray, tree, levelIndex = '', parentFilter = false) {
            var index = 0
            var isResearchFilter = ( parentFilter || false);
            for (const [key, value] of Object.entries(levelArray)) {
                if ((Array.isArray(value) || typeof value === 'object') && isNaN(Number(key))) {
                    if (this.filterResearch && this.filterResearch.trim() !== "" && key.toLowerCase().includes(this.filterResearch.toLowerCase())) {
                        isResearchFilter = true;
                    }
                    var elementType = key.toLowerCase().split('(')
                    var eyeElement = ['aquifère)', 'bâtiment)', 'cavité)', 'cours d\'eau)', 'dépôt)', 'digue)', 'puits de mine)', 'réservoir minier)', 'sondage de décompression)', 'station de relevage des eaux ', 'station de traitement)', 'zone mvt terrain)']
                    var nodeIcon = ''

                    if (key.includes('(Regroupement')) {
                        nodeIcon = 'fa fa-map-marker-alt'
                    } else if (value[0] && value[0].typeAttachement === 1) {
                        nodeIcon = 'fa fa-eye'
                    } else if (value[0] && value[0].typeAttachement === 2) {
                        nodeIcon = 'fa fa-cog'
                    } else if (eyeElement.includes(elementType[1]) || (elementType[2] && eyeElement.includes(elementType[2]))) {
                        nodeIcon = 'fa fa-eye'
                    } else {
                        nodeIcon = 'fa fa-cog'
                    }

                    const response = this.createSurveillanceTree(value, [], (levelIndex !== '' ? levelIndex + index + '-' : index + '-'), isResearchFilter);
                    isResearchFilter = (parentFilter && isResearchFilter);

                    if (response.responseResearchFilter) {
                        const selectableCount = this.countSelectableVariables(response.responseTree);
                        const isTooManyVars = selectableCount > 50;
                        tree.push(
                            {
                                key: levelIndex + '_' + key,
                                label: key,
                                data: { typeElement : elementType[1], childVariableCount: selectableCount },
                                state: { checked: false, selected: false, expanded: false },
                                selectable: !isTooManyVars,
                                icon: nodeIcon,
                                children: response.responseTree
                            }
                        )
                    }
                } else if ((value.codeSuivi == 0 || value.codeSuivi == 1 || value.codeSuivi == 4) || this.affichageSuiviAbandonneOuSuspendu) { // on vérifie si la variable est suivie ou si on veut l'afficher malgré tout
                    if (
                        parentFilter ||
                        (
                            this.filterResearch &&
                            this.filterResearch.trim() !== "" &&
                            (
                                value.libVariable.toLowerCase().includes(this.filterResearch.toLowerCase()) ||
                                value.mnemo?.toLowerCase().includes(this.filterResearch.toLowerCase())
                            )
                        )
                    ) {
                        var hexColor = Math.floor(Math.random() * 16777215).toString(16)
                        var isVariable = !('libVue' in value)
                        var isVariableCalculee = value.idVariableCalculee // Regarde si c'est une variable calculée (vc)
                        var libVariableCalculee = ""
                        if (isVariable && isVariableCalculee) libVariableCalculee = value.libVariable.split('--')[1].trim()
                        var nodeData = {
                            libVariable: isVariable ? (isVariableCalculee ? libVariableCalculee : value.libVariable) : value.libVue,
                            libUnite: (isVariableCalculee && libVariableCalculee.startsWith("Nb")) ? "Aucune" : value.libUnite, // Pour une vc, pas d'unité qd c'est du comptage
                            modeMesure: value.modeMesure,
                            typeElement: value.typeElement,
                            guidVariable: isVariableCalculee ? value.guidVariable + "_" + value.idVariableCalculee : value.guidVariable,
                            idVariableCalculee: value.idVariableCalculee,
                            elementPath: value.elementPath.join(' > '),
                            variableColor: isVariable ? '#' + (parseInt(hexColor, 16) > 0x100000 ? hexColor : '0' + hexColor) : '',
                            variableVisibility: true,
                            showMesureData: false
                        }

                        var node = {
                            key: levelIndex + '_' + (isVariable ? (isVariableCalculee ? value.guidVariable + '_' + value.idVariableCalculee : value.guidVariable) : value.id),
                            label: isVariable ? (isVariableCalculee ? value.libVariable.split('--')[1].trim() : value.libVariable) : value.libVue, // Quand variable calculée : lib = lib_variable + ' -- ' + lib_variable_calculee
                            data: nodeData,
                            state: { checked: false, selected: false, expanded: false },
                            selectable: isVariable, // true variable - false vue
                            styleClass: isVariable ? (isVariableCalculee ? 'node_' + value.guidVariable + ' node_variable_calculee' : 'node_' + value.guidVariable) : 'node_view view_' + value.guidVariable,
                            icon: isVariable ? 'fas fa-chart-bar' : 'fa fa-times-circle'
                        }

                        tree.push(node)
                    }
                }
                index++
            }

            return {"responseTree": tree,"responseResearchFilter": tree.length > 0 }
        },

        async onNodeSelect(node) {
            if (node.selectable) {
                if (node.data.typeElement !== undefined) {
                    // Si c'est un noeud parent avec des enfants, vérifier le nombre de variables
                    if ('children' in node && node.children.length > 0) {
                        const childCount = node.data.childVariableCount ?? this.countSelectableVariables(node.children);

                        if (childCount >= 15 && childCount <= 50) {
                            // Entre 15 et 50 : demander confirmation à l'utilisateur
                            const confirmed = window.confirm(
                                `Vous allez afficher ${childCount} variables. Cela pourrait rendre votre navigateur instable si les variables ont beaucoup de mesures.`
                            );
                            if (!confirmed) {
                                // L'utilisateur a refusé : décocher le noeud et ses enfants
                                this.uncheckNodeAndChildren(node);
                                return;
                            }
                        }
                        // Si < 15 on continue directement, si > 50 c'est bloqué par selectable: false
                    }

                    let newNodes = {};

                    if (!('children' in node)) {
                        newNodes[node.label] = node;
                    } else {
                        newNodes = await this.setSelectedVariables(node, newNodes);
                    }
                    this.getGraphData(newNodes)
                        .catch((error) => {
                            Object.values(newNodes).forEach(n => {
                                delete this.computedSelectedKeys[n.key];
                                this.onNodeUnselect(n, false);
                            });
                        });
                } else if (node.data.id !== undefined) {
                    this.setView({
                        data: {
                            id: node.data.guidVariable
                        }
                    });
                }
            }
        },
        async onNodeUnselect(node, deleteError = true) {
            if (node.data.typeElement !== undefined) {
                if (!('children' in node)) {
                    await this.$store.dispatch('surveillance/deleteVariableData', {variableGuid: node.data.guidVariable, deleteError})
                    let varData = await this.$store.getters['surveillance/surveillanceSelectedVariables'].data
                    if ((varData === null) || (Object.keys(varData).length === 0)) {
                        this.eventBus.emit('reset-graph', {
                            guidsVariables: [],
                            chartLines: {}
                        }, false)
                    }
                } else if ('children' in node) { // Legacy ?
                    await this.setSelectedVariables(node, {}, true)
                }
            }
        },
        uncheckNodeAndChildren(node) {
            // Décocher le noeud parent
            delete this.computedSelectedKeys[node.key];
            // Décocher récursivement tous les enfants
            if (node.children) {
                const recurse = (children) => {
                    children.forEach(child => {
                        delete this.computedSelectedKeys[child.key];
                        if (child.children) {
                            recurse(child.children);
                        }
                    });
                };
                recurse(node.children);
            }
            // Mettre à jour le store
            this.$store.dispatch('surveillance/setSelectedKeys', { selectedKeys: { ...this.computedSelectedKeys } });
        },
        setSelectedVariables(node, nodeList, remove = false) {
            node.children.forEach(async child => {
                // On boucle sur les enfants si il y a
                if ('children' in child) {
                    nodeList = await this.setSelectedVariables(child, nodeList, remove)
                }
                else if (remove) {
                    await this.$store.dispatch('surveillance/deleteVariableData', {variableGuid: child.data.guidVariable})
                } else {
                    nodeList[child.label + "_" + child.data.guidVariable] = child                   
                }

                // On sélectionne/désélectionne les enfants
                this.computedSelectedKeys[child.key] = {
                    checked: !remove,
                }
            })

            return nodeList
        },
        expandElements(nodes) {
            if (!nodes) return
            const newKeys = {}
            const recurse = (list) => {
                list.forEach(item => {
                    newKeys[item.key] = true
                    if (item.children && item.children.length > 0) {
                        recurse(item.children)
                    }
                })
            }
            recurse(nodes)
            this.computedExpandedKeys = newKeys
        },
        findNodeAndParents(guid, nodes = this.getSurveillanceTree, parents = []) {
            if (!nodes) return null
            for (const node of nodes) {
                if (node?.data?.guidVariable === guid) {
                    return { node, parents }
                }
                if (node.children && node.children.length > 0) {
                    const found = this.findNodeAndParents(guid, node.children, [...parents, node.key])
                    if (found) return found
                }
            }
            return null
        },
        async selectAndExpandChronicleVariable(guid) {
            let result = this.findNodeAndParents(guid, this.getSurveillanceTree, [], true)
            if (!result) {
                result = this.findNodeAndParents(guid, this.getSurveillanceTree, [], false)
            }
            if (result) {
                const { node, parents } = result

                const newExpandedKeys = { ...this.computedExpandedKeys }
                parents.forEach(pKey => {
                    newExpandedKeys[pKey] = true
                })
                this.computedExpandedKeys = newExpandedKeys

                const newSelectedKeys = { ...this.computedSelectedKeys }
                newSelectedKeys[node.key] = {
                    checked: true,
                    partialChecked: false
                }
                parents.forEach(pKey => {
                    newSelectedKeys[pKey] = {
                        checked: false,
                        partialChecked: true
                    }
                })
                this.computedSelectedKeys = newSelectedKeys

                await this.onNodeSelect(node)
            }
        },

        getGraphData(nodeList) {
            const guids = [];
            const variablesDetails = [];

            Object.values(nodeList).forEach(function (value) {
                guids.push(value.data.guidVariable);
                variablesDetails[value.data.guidVariable] = value.data;
            });

            if (guids.length >= 1) {
                const dateRange = this.$store.getters['surveillance/dateRange'];
                return this.$store.dispatch('surveillance/getVariablesGrapheur', {
                    variablesGuids: guids,
                    dateDebut: new Date(dateRange.start).toJSON(),
                    dateFin: new Date(dateRange.end).toJSON(),
                    maxMeasureCount: this.$store.getters['surveillance/graphMaxMeasureCount'],
                    variablesDetails: variablesDetails,
                    selectedSurv: this.selectedSurveillance
                });
            }
        },

        resetSelectedVariables() {
            this.$store.dispatch('surveillance/deleteVariablesData', {variablesGuids: Object.keys(this.$store.getters['surveillance/surveillanceSelectedVariables'].data)})
            this.$store.dispatch('surveillance/resetSelectedKeys')
        },
        showLoadViewModal() {
            this.eventBus.emit('show-load-view')
        },
        setView(event) {
            this.$store.dispatch('surveillance/updateSelectedView', {viewId: event.data.id})
        }
    },
    async mounted() {
        const search = window.location.search.substring(1);
        const parts = search.split("&");
        const guidVariable = parts[0];

        if (guidVariable != null && guidVariable != '') {
            this.guidVariableChronique = guidVariable
            this.modalVC = {
                'isChecked' : parts.includes("vc=true"),
                'guid' : this.guidVariableChronique
            }
            await surveillanceService.getVariableFromArbo(guidVariable).then(d => {
                this.selectedUtam = d.utam
                this.selectedSurveillance = d.idSurveillance
            }).catch(e => {
                // eslint-disable-next-line
                console.error("Variable non trouvée dans l'arborescence", e);
            })

            const targetSurv = this.selectedSurveillance;
            await this.getAllSurveillance(this.selectedUtam)
            if (targetSurv) {
                this.selectedSurveillance = targetSurv;
            }
            this.updateSurveillanceTree()
        } else {
            this.selectedUtam = await this.initUtam() // init default selected UTAM and dynamically generated select element
            await this.getAllSurveillance(this.selectedUtam)
            await this.getSurveillanceArborescence()
        }

        document.querySelector('button.resetGraph').addEventListener('click', () => {
            this.selectedSurveillance = null
            this.updateSurveillanceList()
        })
    },
    updated() {
        //this.initUtam()
    }
}
</script>
<style>
.tab-header {
    position: sticky;
    top: 0;
    z-index: 1;
}

h2.tab-title {
    text-align: center;
    font-size: 1.5em;
    text-transform: uppercase;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    padding: 2.87rem 0 1.424rem 0;
    margin: 0;
    white-space: nowrap;
}

.tab-header .row.toolbar {
    margin-bottom: 0px;
}

#extended-surveillance-content > .row.toolbar {
    margin-bottom: 0;
}

.tab-header .uncheckAll {
    border: none;
    background: none;
    line-height: 1.0;
}

.tab-header .uncheckAll:hover {
    cursor: pointer;
}

.tab-header .uncheckAll .unckeck-icon {
    position: relative;
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    background-color: gray;
    margin-right: 10px;
}

.tab-header .uncheckAll .unckeck-icon:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    display: inline-block;
    width: 9px;
    height: 2px;
    background: white;
    transform: translate(-50%, -50%);
}

.tab-header .uncheckAll .uncheck-label {
    vertical-align: text-top;
    font-size: 16px;
    font-weight: 500;
    color: #656565;
}

#load-view-open {
    display: inline-block;
    padding-bottom: 5px;
}

#load-view-open button.showLoadView {
    margin-left: 0.75rem;
    line-height: 1.0;
    border: none;
    background: none;
    padding: 0;
    white-space: nowrap;
    overflow: hidden;
}

#load-view-open button.showLoadView:hover {
    cursor: pointer;
}

#load-view-open button.showLoadView .load-view-icon {
    display: inline;
    width: 20px;
    height: 30px;
    color: #e57525;
    margin: 0;
}

#load-view-open button.showLoadView .load-view-label {
    vertical-align: super;
    font-size: initial;
    font-weight: 500;
    color: #656565;
    margin-left: 0.75rem;
}

.p-tree {
    border: none;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}

.p-treenode-content[aria-expanded="true"] .p-treenode-label {
    font-weight: bold;
}

.p-treenode > .p-treenode-children {
    padding: 0;
    margin: 0 0 0 1rem;
    border-left: 1px dotted #e57525;
}

.p-treenode-content .p-tree-toggler-icon:before {
    color: #e57525;
}

.p-tree .p-tree-container > .p-treenode {
    padding-left: 0;
    padding-right: 0;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight {
    background: none;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content.node_view:hover {
    cursor: pointer;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:hover,
.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:enabled:hover {
    background: none;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:focus,
.p-link:focus {
    box-shadow: none;
}

.p-checkbox .p-checkbox-box {
    border-color: #e57525;
    border-width: 1px;
}

.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
    border-color: #78909c;
}

.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {
    border-color: #78909c;
    background-color: #78909c;
}

.p-checkbox .p-checkbox-box.p-highlight {
    border-color: #e57525;
    background: #e57525;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content .p-treenode-icon,
.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-treenode-icon,
.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-treenode-icon:hover {
    color: #e57525;
}


.input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
}

.input-wrapper input {
    width: 100%;
    padding-right: 35px; /* Laisse de la place pour l'icône */
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    outline: none;
}

.input-wrapper .icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;

}
#filterArbo{
    margin-top:unset;
}
.node_variable_calculee {
    padding-left: 0.5em;
    font-size: 13px;
    font-style: italic;
}
.node_variable_calculee .p-checkbox-box {
    height: 18px;
    width: 18px;
}
#affichage-suivi, #expand-all{
    position: unset;
    opacity: unset;
    pointer-events: unset;
}
#affichage-suivi-div, #expand-all-div{
    display: flex;
    margin-left: 0.2em;
}
#affichage-suivi-label, #expand-all-label {
    margin-right: 0.2em;
}
#expand-all:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
#message-surv-sans-var {
    margin: 20px 0px -12px 5px;
    color: red;
}
</style>
